var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row reports-occurrences-summary" }, [
    _c("div", { staticClass: "col" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("table-resume", {
              attrs: {
                title: _vm.title,
                route: _vm.route,
                externalFilters: _vm.filters,
                extraQueryParams: _vm.extraQueryParams,
                autoUpdateExternalFilter: _vm.autoUpdateExternalFilter,
                autoUpdateFilter: true,
                showTitleData: false,
                titleClass: "subtitle",
                settings: _vm.settings,
                columns: _vm.columns,
                loadingMsg: _vm.loadingMsg,
                notFoundMsg: _vm.notFoundMsg,
                orderByTemplate: _vm.orderByTemplate,
                confirmExportData: false,
                allowExportData: _vm.allowExportData,
                titleExportData: _vm.titleExportData,
                confirmMsgExportData: _vm.confirmMsgExportData,
                errorMsgExportData: _vm.errorMsgExportData,
                tableWrapperClass: "bg-lilac-light",
                tableClass: "table-responsive-sm",
                funcExportData: _vm.onExport,
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function ({ row, index }) {
                    return _vm._l(_vm.columns, function (column) {
                      return _c("td", { class: column.class }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.columnValue(row, column)) +
                            "\n                        "
                        ),
                      ])
                    })
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }